import React, { ReactElement } from 'react';

import Icon from 'atomic/icon/icon';
import { useLocation } from 'hooks/use-location';
import Link from 'atomic/link/link';

const DSA_TITLE = 'Zgłoś kwestię prawną';

export interface DsaLinkProps {
    url?: string;
    className?: string;
    iconOnly?: boolean;
}

const DsaLink: React.FC<DsaLinkProps> = (
    {
        url,
        className,
        iconOnly
    }
): ReactElement => {
    let contentUrl = url;

    if (contentUrl === void 0) {
        const { location } = useLocation();

        contentUrl = `https://www.opineo.pl${location.url}`;
    }

    if (contentUrl.startsWith('/')) {
        contentUrl = `https://www.opineo.pl${contentUrl}`;
    }

    const href = `https://www.opineo.pl/report-notice/index.html${contentUrl ? `?content_url=${encodeURIComponent(contentUrl)}` : ''}`;

    return (
        <Link
            href={href}
            target="_blank"
            rel="noreferrer"
            className={className}
            title={iconOnly ? DSA_TITLE : undefined}
        >
            <Icon icon="envelope" />
            {!iconOnly && ` ${DSA_TITLE}`}
        </Link>
    );
};

export default DsaLink;
